<div class="add-visual">
    <div class="add-filter__toolbar" *ngIf="!isAccordion && elements[0] as filterElement">
        <button type="button" class="add-filter__global-filter-btn" (click)="onOpenTableFilter(filterElement)">
            <span>Manage table filter{{ getFilterCountLabel(filterElement.tableFilters) }}</span>
        </button>
        <button type="button" class="add-filter__global-filter-btn" (click)="onOpenGlobalFilter(filterElement)">
            <span>Manage column filter{{ getFilterCountLabel(filterElement.globalFilters) }}</span>
        </button>
    </div>

    <div class="add-visual__field-row add-visual__field-row--heading"
        [class.add-visual__field-row--multiple]="isAccordion">
        <div class="add-visual__field add-visual__field--heading-title">
            <label class="add-visual__label" for="visual-heading">
                Visual heading <span class="mandatory">*</span>
            </label>
            <input id="visual-heading" type="text" class="add-filter__input" placeholder="Enter visual heading"
                [ngModel]="heading" (ngModelChange)="onHeadingChange($event)" />
        </div>
        <ng-container *ngIf="!isAccordion">
            <ng-container *ngIf="elements[0] as element">
                <ng-container *ngTemplateOutlet="columnPicker; context: { $implicit: element }"></ng-container>
            </ng-container>
        </ng-container>
        <div class="add-visual__field add-visual__field--applied" *ngIf="!isAccordion && elements[0] as element">
            <label class="add-visual__label">Select filters <mat-icon class="add-visual__info" title="Select the filter name for the visual, used for filtering data" aria-label="Select the filter name for the visual, used for filtering data">info_outline</mat-icon></label>
            <mat-select class="add-filter__select" aria-label="Applied filters" multiple panelClass="add-visual-filter-panel"
                [placeholder]="filterOptions.length ? 'Select filters' : 'No filter available'"
                [disabled]="!filterOptions.length" [ngModel]="element.appliedFilters"
                (ngModelChange)="onAppliedFiltersChange(element, $event)">
                <mat-option *ngFor="let name of filterOptions; trackBy: trackByKey" [value]="name">{{ name }}</mat-option>
            </mat-select>
        </div>
        <div class="add-visual__field add-visual__field--properties">
            <span class="add-visual__label" aria-hidden="true">&nbsp;</span>
            <button type="button" class="add-filter__icon-btn" title="Manage chart properties"
                aria-label="Manage chart properties" (click)="openChartProperties(); $event.stopPropagation()">
                <mat-icon>tune</mat-icon>
            </button>
        </div>
    </div>

    <ng-container *ngIf="!isAccordion; else accordionList">
        <ng-container *ngIf="elements[0] as element">
            <ng-container *ngTemplateOutlet="elementBody; context: { $implicit: element }"></ng-container>
        </ng-container>
    </ng-container>

    <ng-template #accordionList>
        <div class="add-visual__accordion">
            <div class="add-visual__panel" *ngFor="let element of elements; let index = index; trackBy: trackByElementId"
                [class.add-visual__panel--open]="isExpanded(element)">
                <button type="button" class="add-visual__panel-head" [attr.aria-expanded]="isExpanded(element)"
                    (click)="toggleExpanded(element)">
                    <mat-icon aria-hidden="true" class="add-visual__panel-chevron"
                        [class.add-visual__panel-chevron--collapsed]="!isExpanded(element)">expand_more</mat-icon>
                    <span class="add-visual__panel-title">Element {{ index + 1 }}</span>
                    <span class="add-visual__panel-summary">{{ getElementSummary(element) }}</span>
                </button>
                <div class="add-visual__panel-body" *ngIf="isExpanded(element)">
                    <ng-container *ngTemplateOutlet="elementBody; context: { $implicit: element }"></ng-container>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #columnPicker let-element>
      <div class="add-visual__field add-visual__field--column-picker">
        <label class="add-visual__label">Select column <span class="mandatory">*</span></label>
        <mat-select class="add-filter__select add-filter__data-select" placeholder="Select data columns"
            multiple panelClass="add-filter-data-column-panel" aria-label="Data columns"
            [ngModel]="element.columns" (ngModelChange)="onColumnsChange(element, $event)"
            (openedChange)="onPickerOpenedChange(pickerId(element, 'columns'), $event)">
            <mat-select-trigger>
                <span class="add-filter__data-select-value"
                    [class.add-filter__data-select-value--placeholder]="!element.columns.length">
                    {{ getColumnsLabel(element) || 'Select data columns' }}
                </span>
            </mat-select-trigger>

            <div class="add-filter__data-panel-head" (click)="$event.stopPropagation()">
                <span class="add-filter__data-panel-title">Selected data columns</span>
                <span class="add-filter__data-panel-count">{{ getSelectedColumnCountLabel(element) }}</span>
            </div>
            <div class="add-filter__data-panel-search" (click)="$event.stopPropagation()">
                <mat-icon aria-hidden="true">search</mat-icon>
                <input type="text" placeholder="Search columns..." [ngModel]="searchTerm[pickerId(element, 'columns')]"
                    (ngModelChange)="onSearchChange(pickerId(element, 'columns'), $event)"
                    (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
            </div>
            <div class="add-visual__panel-actions" (click)="$event.stopPropagation()">
                <label class="add-visual__select-all">
                    <input type="checkbox" [checked]="areAllVisibleSelected(element)"
                        [indeterminate]="areSomeVisibleSelected(element)"
                        (change)="toggleSelectAllVisible(element, $any($event.target).checked)" />
                    <span>Select all</span>
                </label>
            </div>

            <ng-container *ngFor="let group of getFilteredGroups(pickerId(element, 'columns')); trackBy: trackByColumnGroup">
                <div class="add-filter__data-group-head"
                    (click)="toggleGroup(pickerId(element, 'columns'), group); $event.stopPropagation()">
                    <mat-icon aria-hidden="true" class="add-filter__data-group-chevron"
                        [class.add-filter__data-group-chevron--collapsed]="isGroupCollapsed(pickerId(element, 'columns'), group)">expand_more</mat-icon>
                    <span class="add-filter__data-group-name">{{ group.group }}</span>
                    <span class="add-filter__data-group-count">{{ group.columns.length }} column{{ group.columns.length === 1 ? '' : 's' }}</span>
                </div>
                <mat-option *ngFor="let column of group.columns; trackBy: trackByColumnOption" [value]="column.key"
                    class="add-filter__data-option add-filter__data-option--checkbox"
                    [class.add-filter__data-option--selected]="isColumnSelected(element, column.key)"
                    [hidden]="isGroupCollapsed(pickerId(element, 'columns'), group)">
                    <div class="add-filter__data-option-row"
                        (click)="toggleColumn(element, column.key); $event.stopPropagation()">
                        <span class="add-filter__data-option-checkbox"
                            [class.add-filter__data-option-checkbox--checked]="isColumnSelected(element, column.key)"></span>
                        <span class="add-filter__data-option-body">
                            <span class="add-filter__data-option-name">{{ column.displayName }}</span>
                            <span class="add-filter__data-option-dot" *ngIf="getColumnMeta(column)">•</span>
                            <span class="add-filter__data-option-meta" *ngIf="getColumnMeta(column)">{{ getColumnMeta(column) }}</span>
                        </span>
                        <span class="add-filter__data-option-badge" *ngIf="isColumnSelected(element, column.key)">Selected</span>
                    </div>
                </mat-option>
            </ng-container>
            <p class="add-filter__data-empty" *ngIf="!getFilteredGroups(pickerId(element, 'columns')).length">No columns found.</p>
        </mat-select>
      </div>
    </ng-template>

    <ng-template #elementBody let-element>
        <div class="add-filter__toolbar" *ngIf="isAccordion">
            <button type="button" class="add-filter__global-filter-btn" (click)="onOpenTableFilter(element)">
                <span>Manage table filter{{ getFilterCountLabel(element.tableFilters) }}</span>
            </button>
            <button type="button" class="add-filter__global-filter-btn" (click)="onOpenGlobalFilter(element)">
                <span>Manage column filter{{ getFilterCountLabel(element.globalFilters) }}</span>
            </button>
        </div>

        <div class="add-visual__fields">
          <div class="add-visual__field-row add-visual__field-row--details"
              [class.add-visual__field-row--multiple-details]="isAccordion">
            <ng-container *ngIf="isAccordion">
                <ng-container *ngTemplateOutlet="columnPicker; context: { $implicit: element }"></ng-container>
            </ng-container>
            <!-- Total count: single column + DISTINCT. -->
            <div class="add-visual__field">
                <div class="add-visual__control-group">
                    <label class="add-visual__label">Data count <mat-icon class="add-visual__info" title="Key used to get total data count" aria-label="Key used to get total data count">info_outline</mat-icon></label>
                    <div class="add-visual__inline">
                        <mat-select class="add-filter__select add-filter__data-select" placeholder="Select column"
                            panelClass="add-filter-data-column-panel" aria-label="Data count"
                            [ngModel]="element.totalCountColumn" (ngModelChange)="onTotalCountColumnChange(element, $event)"
                            (openedChange)="onPickerOpenedChange(pickerId(element, 'count'), $event)">
                        <mat-select-trigger>
                            <span class="add-filter__data-select-value"
                                [class.add-filter__data-select-value--placeholder]="!element.totalCountColumn">
                                {{ getTotalCountLabel(element) || 'Select column' }}
                            </span>
                        </mat-select-trigger>

                        <div class="add-filter__data-panel-search" (click)="$event.stopPropagation()">
                            <mat-icon aria-hidden="true">search</mat-icon>
                            <input type="text" placeholder="Search columns..." [ngModel]="searchTerm[pickerId(element, 'count')]"
                                (ngModelChange)="onSearchChange(pickerId(element, 'count'), $event)"
                                (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
                        </div>
                        <mat-option [value]="null" class="add-filter__data-option">None</mat-option>

                        <ng-container *ngFor="let group of getFilteredGroups(pickerId(element, 'count')); trackBy: trackByColumnGroup">
                            <div class="add-filter__data-group-head"
                                (click)="toggleGroup(pickerId(element, 'count'), group); $event.stopPropagation()">
                                <mat-icon aria-hidden="true" class="add-filter__data-group-chevron"
                                    [class.add-filter__data-group-chevron--collapsed]="isGroupCollapsed(pickerId(element, 'count'), group)">expand_more</mat-icon>
                                <span class="add-filter__data-group-name">{{ group.group }}</span>
                                <span class="add-filter__data-group-count">{{ group.columns.length }} column{{ group.columns.length === 1 ? '' : 's' }}</span>
                            </div>
                            <mat-option *ngFor="let column of group.columns; trackBy: trackByColumnOption" [value]="column.key"
                                class="add-filter__data-option" [hidden]="isGroupCollapsed(pickerId(element, 'count'), group)">
                                <span class="add-filter__data-option-body">
                                    <span class="add-filter__data-option-name">{{ column.displayName }}</span>
                                    <span class="add-filter__data-option-dot" *ngIf="getColumnMeta(column)">•</span>
                                    <span class="add-filter__data-option-meta" *ngIf="getColumnMeta(column)">{{ getColumnMeta(column) }}</span>
                                </span>
                            </mat-option>
                        </ng-container>
                        <p class="add-filter__data-empty" *ngIf="!getFilteredGroups(pickerId(element, 'count')).length">No columns found.</p>
                        </mat-select>
                        <label class="add-visual__checkbox">
                            <input type="checkbox" [ngModel]="element.totalCountDistinct" [disabled]="!element.totalCountColumn"
                                (ngModelChange)="onDistinctChange(element, $event)" />
                            <span>Distinct</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="add-visual__field" *ngIf="isAccordion">
                <label class="add-visual__label">Select data filters <mat-icon class="add-visual__info" title="Select the filter name for the visual, used for filtering data" aria-label="Select the filter name for the visual, used for filtering data">info_outline</mat-icon></label>
                <mat-select class="add-filter__select" aria-label="Applied filters" multiple panelClass="add-visual-filter-panel"
                    [placeholder]="filterOptions.length ? 'Select filters' : 'No filter available'"
                    [disabled]="!filterOptions.length" [ngModel]="element.appliedFilters"
                    (ngModelChange)="onAppliedFiltersChange(element, $event)">
                    <mat-option *ngFor="let name of filterOptions; trackBy: trackByKey" [value]="name">{{ name }}</mat-option>
                </mat-select>
            </div>

            <div class="add-visual__field">
                <div class="add-visual__control-group">
                    <div class="add-visual__control-group-head">
                        <label class="add-visual__label">Default attributes <mat-icon class="add-visual__info" title="Keys used to provide data based on these keys" aria-label="Keys used to provide data based on these keys">info_outline</mat-icon></label>
                        <div class="add-visual__attribute-toggle" role="group" aria-label="Default attributes visibility">
                            <span>Hide</span>
                            <label class="add-visual__switch">
                                <input type="checkbox" role="switch" aria-label="Show default attributes"
                                    [ngModel]="element.isAttributeVisible"
                                    (ngModelChange)="onAttributeVisibleChange(element, $event)" />
                                <span class="add-visual__switch-track"></span>
                            </label>
                            <span>Show</span>
                        </div>
                    </div>
                        <mat-select class="add-filter__select add-filter__data-select" aria-label="Default attributes" multiple
                            [placeholder]="element.columns.length ? 'Select attributes' : 'Select data columns first'"
                            [disabled]="!element.columns.length" [ngModel]="element.defaultAttributes"
                            panelClass="add-filter-data-column-panel"
                            (openedChange)="onDefaultAttributeSelectOpened(element, $event)"
                            (ngModelChange)="onDefaultAttributesChange(element, $event)">
                            <mat-select-trigger>
                                <span class="add-filter__data-select-value"
                                    [class.add-filter__data-select-value--placeholder]="!element.defaultAttributes.length">
                                    {{ getDefaultAttributesLabel(element) || 'Select attributes' }}
                                </span>
                            </mat-select-trigger>

                            <div class="add-filter__data-panel-search" (click)="$event.stopPropagation()">
                                <mat-icon aria-hidden="true">search</mat-icon>
                                <input type="text" placeholder="Search attributes..."
                                    [ngModel]="defaultAttributeSearch[element.id]"
                                    (ngModelChange)="onDefaultAttributeSearchChange(element, $event)"
                                    (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
                            </div>
                            <div class="add-visual__panel-actions" (click)="$event.stopPropagation()">
                                <label class="add-visual__select-all">
                                    <input type="checkbox" [checked]="areAllDefaultAttributesSelected(element)"
                                        [indeterminate]="areSomeDefaultAttributesSelected(element)"
                                        (change)="toggleSelectAllDefaultAttributes(element, $any($event.target).checked)" />
                                    <span>Select all</span>
                                </label>
                            </div>

                            <!-- Selection is driven by our own toggle (not Material's multi-select model) so the panel stays open between picks. -->
                            <mat-option *ngFor="let key of getFilteredDefaultAttributes(element); trackBy: trackByKey"
                                [value]="key" class="add-filter__data-option add-filter__data-option--checkbox"
                                [class.add-filter__data-option--selected]="isDefaultAttributeSelected(element, key)">
                                <div class="add-filter__data-option-row"
                                    (click)="toggleDefaultAttribute(element, key); $event.stopPropagation()">
                                    <span class="add-filter__data-option-checkbox"
                                        [class.add-filter__data-option-checkbox--checked]="isDefaultAttributeSelected(element, key)"></span>
                                    <span class="add-filter__data-option-body">
                                        <span class="add-filter__data-option-name">{{ getLabel(element, key) }}</span>
                                    </span>
                                    <span class="add-filter__data-option-badge" *ngIf="isDefaultAttributeSelected(element, key)">Selected</span>
                                </div>
                            </mat-option>
                            <p class="add-filter__data-empty" *ngIf="!getFilteredDefaultAttributes(element).length">No attributes found.</p>
                        </mat-select>
                </div>
            </div>
          </div>
        </div>
    </ng-template>

    <app-property-panel [open]="chartPropertyPanelOpen" title="Manage chart properties" width="400px"
        [fields]="chartPropertyFields" [values]="chartPropertyValues"
        (valueChange)="onChartPropertyValueChange($event)" (closed)="closeChartProperties()">
    </app-property-panel>
</div>


<app-modal [maximizable]="true" [inViewport]="true" #globalFilterModal class="modal-demo global-filter-popup"
    (closeModal)="onGlobalFilterCancelled()">
    <ng-container class="app-modal-header">Manage column filter</ng-container>
    <ng-container class="app-modal-body">
        <app-global-filter-modal #globalFilterModalBody [columnOptions]="globalFilterColumnOptions"
            (cancelled)="onGlobalFilterCancelled()" (conditionsSaved)="onGlobalFilterSaved($event)">
        </app-global-filter-modal>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #tableFilterModal class="modal-demo global-filter-popup"
    (closeModal)="onTableFilterCancelled()">
    <ng-container class="app-modal-header">Manage table filter</ng-container>
    <ng-container class="app-modal-body">
        <app-global-filter-modal #tableFilterModalBody mode="table" [columnOptions]="globalFilterColumnOptions"
            (cancelled)="onTableFilterCancelled()" (conditionsSaved)="onTableFilterSaved($event)">
        </app-global-filter-modal>
    </ng-container>
</app-modal>
